<template>
  <div class="environment">
    <el-carousel :interval="4000" type="card" :height="bannerHeight">
      <el-carousel-item v-for="item in banner" :key="item">
        <img :src="item" alt />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banner: [
        require('../../../assets/images/join/environment/ban1.jpg'),
        require('../../../assets/images/join/environment/ban2.jpg'),
        require('../../../assets/images/join/environment/ban3.jpg'),
        require('../../../assets/images/join/environment/ban4.jpg')
      ],
      screenWidth: document.body.clientWidth
    }
  },
  created() {},
  mounted() {
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }
  },
  methods: {},
  computed: {
    bannerHeight() {
      if (this.screenWidth >= 850) {
        return '380px'
      } else {
        return '150px'
      }
    }
  }
}
</script>

<style scoped>
.environment {
  width: 100%;
  max-width: 1100px;
  margin: 30px auto;
}
.environment .el-carousel img {
  width: 100%;
}
</style>
